// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3-4vn","question":"styles_question__18j_h","description":"styles_description__2H_3Q"};